import { handleActions } from 'redux-actions';

import * as constants from './constants';

export const initialState = {
  googlePlaces: [],
  googlePlacesInputSelect: [],
  searchType: { key: 'establishment', value: 'Business Name' },
  selectedGooglePlace: null,
  isGooglePlacesLoading: false,
};

function resetGooglePlaces(state) {
  return {
    ...state,
    googlePlaces: [],
    googlePlacesInputSelect: [],
  };
}

function sendGooglePlacesRequest(state) {
  return {
    ...state,
    isGooglePlacesLoading: true,
  };
}

function setGooglePlaces(state, { payload }) {
  const googlePlaces = (payload || []).map(place => ({
    ...place,
    label: place.description,
  }));

  return {
    ...state,
    isGooglePlacesLoading: false,
    googlePlaces,
    googlePlacesInputSelect: (googlePlaces || []).map(place => ({
      value: place,
      label: place.description,
    })),
  };
}

function selectGooglePlace(state, { payload }) {
  const selectedGooglePlace = payload;

  return {
    ...state,
    selectedGooglePlace,
  };
}

function updateSearchType(state, { payload }) {
  return {
    ...state,
    searchType: payload,
  };
}

function resetGooglePlace(state) {
  return {
    ...state,
    selectedGooglePlace: null,
  };
}

export default handleActions(
  {
    [constants.RESET_GOOGLE_PLACES]: resetGooglePlaces,
    [constants.SET_GOOGLE_PLACES_REQUEST]: sendGooglePlacesRequest,
    [constants.SET_GOOGLE_PLACES]: setGooglePlaces,
    [constants.SELECT_GOOGLE_PLACE]: selectGooglePlace,
    [constants.RESET_GOOGLE_PLACE]: resetGooglePlace,
    [constants.UPDATE_SEARCH_TYPE]: updateSearchType,
  },
  initialState
);
